import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["innerHTML"];
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
import { debounce } from "@utils/functionUtils";
import { ref, watch, onBeforeMount, computed } from "vue";
import SelectItem from "@vueEntry/UIKitComponents/BaseSelect/SelectItem.vue";
import { useKeyboardController } from "@wkComposables/useKeyboardController";
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAutocomplete',
  props: /*#__PURE__*/_mergeModels({
    border: {
      type: Boolean,
      default: true
    },
    isValid: {
      default: null
    },
    theme: {
      default: ""
    },
    label: {
      default: ""
    },
    disableCb: {
      type: Boolean,
      default: false
    },
    onInputChangeCb: {},
    onOptionSelectedCb: {
      default: null
    },
    manualClose: {
      type: Boolean,
      default: false
    },
    keepState: {
      default: null
    }
  }, {
    "modelValue": {
      default() {
        return {
          id: "",
          label: ""
        };
      }
    },
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["dropdownClosed", "changedValue", "click"], ["update:modelValue"]),
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var props = __props;
    /** The modelValue holds the value of one of the selectItems. If empty, it means that no selectItem has been selected */
    var modelValue = _useModel(__props, "modelValue");
    var emits = __emit;
    var curValue = ref("");
    var options = ref([]);
    var debouncedCallback = ref(null);
    var selection = ref(false);
    var openDropdown = ref(false);
    var baseInput = ref(null);
    var optionsLength = computed(() => options.value.length);
    onBeforeMount(() => {
      var _a;
      curValue.value = ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.label) || "";
      debouncedCallback.value = debounce({
        delay: 300
      }, props.onInputChangeCb);
    });
    var {
      activeIdx,
      selectedIdx
    } = useKeyboardController({
      optionsLength: optionsLength,
      isDropdownOpen: openDropdown,
      disableSpaceHandler: true
    });
    var inputClasses = computed(() => {
      switch (props.theme) {
        case "bordered":
          return "";
        case "all-bordered":
          return "tw-rounded " + (openDropdown.value && "tw-rounded-b-none");
        case "all-bordered-thick":
          return "tw-rounded-xl !tw-h-[60px] " + (openDropdown.value && "tw-rounded-b-none");
        default:
          return "";
      }
    });
    var fieldsetClasses = computed(() => {
      switch (props.theme) {
        case "bordered":
          return "";
        case "all-bordered":
          return "tw-border tw-border-w-lavender tw-border-solid tw-rounded " + (openDropdown.value ? "tw-border-b-0 tw-rounded-b-none" : "");
        case "all-bordered-thick":
          return "tw-rounded-xl !tw-h-[60px]" + (openDropdown.value && "tw-rounded-b-none");
        default:
          return "";
      }
    });
    var themeClasses = computed(() => {
      var commonThickClasses = "tw-rounded-b-xl tw-shadow " + "tw-rounded-t-none " + "tw-mb-0 !tw-mt-0 tw-text-w-black " + "!tw-rounded-b-xl !tw-rounded-t-none";
      switch (props.theme) {
        case "bordered":
          //bordered classes
          return "before:tw-content-[''] before:tw-absolute before:tw-w-1/2 " + "before:tw-border-b before:tw-border-b-w-lavender before:[border-bottom-style:solid] before:tw-right-1/4 " + "tw-rounded-b-xl tw-shadow " + "tw-rounded-t-none tw-mt-5px tw-mb-0";
        case "all-bordered":
          return commonThickClasses;
        case "all-bordered-thick":
          return commonThickClasses;
        default:
          return "";
      }
    });
    var handleChangedValue = v => __awaiter(this, void 0, void 0, function* () {
      //If nothing has changed, I won't do anything
      if (curValue.value === v) return;
      emits("changedValue", v);
      curValue.value = v;
      if (!props.onInputChangeCb) return;
      // If there is no value, we will update the modelValue
      if (modelValue.value && !v) {
        modelValue.value.label = "";
        openDropdown.value = false;
      }
      /* In case the input is null, empty or we have selected an optionItem, we clean up the options array */
      if (!v || selection.value) {
        options.value = [];
        selection.value = false;
        selectedIdx.value = -1;
        activeIdx.value = -1;
        //Invalidating the callback
        yield debouncedCallback.value(null);
        return;
      }
      if (props.disableCb) return;
      options.value = yield debouncedCallback.value(v);
      //Opening the dropdown iff there is something to show
      if (options.value.length) openDropdown.value = true;
    });
    var handleSelection = (opt, optIdx) => {
      if (props.onOptionSelectedCb) props.onOptionSelectedCb(opt);
      selection.value = true;
      curValue.value = opt.label;
      //Triggering event update:modelValue
      modelValue.value = opt;
      //Closing the dropdown
      openDropdown.value = false;
      selectedIdx.value = optIdx;
    };
    var openDropdownWithOptions = () => {
      if (!options.value.length) return;
      if (props.keepState === "closed") return;
      openDropdown.value = true;
    };
    watch(modelValue, (cur, prev) => {
      if (cur === prev) return;
      curValue.value = (cur === null || cur === void 0 ? void 0 : cur.label) || "";
    });
    watch(selectedIdx, curIdx => {
      var _a;
      if (curIdx === -1) return;
      var optionSelected = options.value[curIdx];
      /* In case we select the same option as before, we will do nothing */
      if (selection.value && optionSelected.label === ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.label)) return;
      handleSelection(optionSelected, curIdx);
    });
    watch(() => props.manualClose, cur => {
      if (!cur) return;
      //Cleaning up the options just when the user has selected an option!
      if (selection.value) options.value = [];
      emits("dropdownClosed");
    });
    var select = () => {
      var _a;
      (_a = baseInput.value) === null || _a === void 0 ? void 0 : _a.select();
    };
    __expose({
      select
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BaseDropDown, {
        class: _normalizeClass(_ctx.$attrs['root-classes']),
        "data-cy": "ac_".concat(_ctx.$attrs['data-cy']),
        "dropdown-element": "ul",
        "dropdown-classes": [{
          'bordered-dropdown': _ctx.theme === 'bordered'
        }, {
          'all-bordered-dropdown': _ctx.theme === 'all-bordered'
        }, {
          'all-bordered-dropdown thick': _ctx.theme === 'all-bordered-thick'
        }, {
          'tw-mt-10px !tw-border !tw-border-w-secondary !tw-rounded-xs': !_ctx.theme
        }, themeClasses.value, '!tw-max-h-[210px] tw-z-10', _ctx.$attrs['dropdown-classes']],
        "open-dropdown": openDropdown.value,
        "keep-state": !options.value.length ? 'closed' : '',
        "onUpdate:dropdownState": _cache[0] || (_cache[0] = v => openDropdown.value = v),
        onClick: _cache[1] || (_cache[1] = $event => {
          emits('click');
          openDropdownWithOptions();
        })
      }, {
        btn_slot: _withCtx(() => {
          var _a;
          return [_createVNode(BaseInput, {
            id: "ac_input_".concat(_ctx.$attrs.id),
            ref_key: "baseInput",
            ref: baseInput,
            "data-cy": "ac_input_".concat(_ctx.$attrs.id),
            "label-text": _ctx.label,
            "model-value": ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.label) || '',
            "is-valid": _ctx.isValid,
            disabled: _ctx.$attrs['disabled'],
            placeholder: _ctx.$attrs['placeholder'],
            "with-left-icon": !!_ctx.$slots.lefticon,
            "with-right-icon": !!_ctx.$slots.righticon,
            border: !_ctx.theme,
            radius: !_ctx.theme || _ctx.theme === 'bordered',
            "input-class": [inputClasses.value, _ctx.$attrs['input-classes']],
            "fieldset-classes": [fieldsetClasses.value, _ctx.$attrs['fieldset-classes']],
            "keep-floating-label": !!curValue.value,
            "onUpdate:modelValue": handleChangedValue
          }, {
            leftIcon: _withCtx(() => [_renderSlot(_ctx.$slots, "lefticon")]),
            righticon: _withCtx(_ref2 => {
              var {
                handleClean
              } = _ref2;
              return [_renderSlot(_ctx.$slots, "righticon", {
                handleClean: handleClean
              })];
            }),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["id", "data-cy", "label-text", "model-value", "is-valid", "disabled", "placeholder", "with-left-icon", "with-right-icon", "border", "radius", "input-class", "fieldset-classes", "keep-floating-label"])];
        }),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, idx) => {
          return _openBlock(), _createBlock(SelectItem, {
            key: idx,
            active: _unref(activeIdx) === idx,
            class: "tw-py-10px tw-px-5 tw-m-1 tw-rounded-[5px] hover:tw-cursor-pointer",
            onClick: $event => handleSelection(option, idx),
            onMouseover: $event => activeIdx.value = idx
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              innerHTML: option.label
            }, null, 8 /* PROPS */, _hoisted_1)]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "onClick", "onMouseover"]);
        }), 128 /* KEYED_FRAGMENT */))]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["class", "data-cy", "dropdown-classes", "open-dropdown", "keep-state"]);
    };
  }
});